import { render, staticRenderFns } from "./ShareFolderButton.vue?vue&type=template&id=25467cf2"
import script from "./ShareFolderButton.vue?vue&type=script&lang=js"
export * from "./ShareFolderButton.vue?vue&type=script&lang=js"
import style0 from "./ShareFolderButton.vue?vue&type=style&index=0&id=25467cf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports